import { qS, qSA } from './_default.js';
import { notifications } from './notifications.js';
import { translations } from './translations.js';
import { activities } from './activities.js';

const landing = {
  init: async function(){
    // Initialize translations
    await translations.init();

    // Show page
    qS('#page_landing').classList.remove('page-loading');
    
    // Scroll page if below 800px width (must be shown before)
    if (window.innerWidth < 800) {
      window.scrollTo(0, 215);
    }

    // Initialize notifications and info bar
    notifications.init();

    // Track page view
    activities.initAndTrackPageview();
  }
}

window.onload = () => landing.init(); 